import usePageTitle from '../hooks/usePageTitle';
import useBrowserDetection from '../hooks/useBrowserDetection';
import { GiCardboardBox } from "react-icons/gi";
import StandardLink from "../tools/StandardLink";
import { ReactComponent as DLogo } from '../assets/d_Logo.svg';

import("../styles/extension.scss");

function Extension() {
  usePageTitle('Browser Extensions | Dochano');

  const browser = useBrowserDetection();
  
  return (
    <section className="extension-container jobPost">
      <div id="Intro">

        <div id="extensionMarquee" title="Job Posting Extractor Marquee">
            <div className="marquee">
                <DLogo width="300px" height="300px" />
                <GiCardboardBox id="cardboardBox" size="5em" />
                
                <div id="promotionalText">
                    <span>Job Post Extractor</span>
                    <span className="promotional-main">gather job details for local storage</span>
                    <span className="promotional-sub">Create TXT file and/or comma delimited information to paste into Excel or Google Sheets.</span>
                </div>
            </div>
            
           
            <StandardLink href={require('../assets/Spreadsheet-Excel.png')} title="Excel Example">
                <div alt="Excel Spreadsheet Example" className="excel-spreadsheet"></div>
            </StandardLink>

            <StandardLink href={require('../assets/Spreadsheet-Google.png')} title="Google Sheets Example">
                <div alt="Google Sheets Example" className="google-sheets"></div>
            </StandardLink>

            <StandardLink href={require('../assets/Txt-File-Example.png')} title="Text File Example">
                <div alt="Text File Example" className="txt-file"></div>
            </StandardLink>

            <StandardLink href={require('../assets/Extension-Usage.png')} title="Extension Usage Example">
                <div alt="Working Extension Example" className="extension-usage"></div>
            </StandardLink>

            <div className="footnote">
                Brought to you by <strong>Dochano</strong>
            </div>
        </div>

      </div>

    <h3>Available Now</h3>
        <ul>
            <li><strong><StandardLink href="https://microsoftedge.microsoft.com/addons/detail/job-post-extractor/npekmaldoanmfpcgoomnbnegfmnmdkkf">Microsoft Edge</StandardLink></strong> - {browser === "Microsoft Edge" ? "Detected, click link to download now" : " Incompatible with your browser"}</li>
            <li><strong><StandardLink href="https://chromewebstore.google.com/detail/job-post-extractor/odgdlbkmghpfbgppjabaohhhjnhddeae">Google Chrome</StandardLink></strong> - {browser === "Chrome" ? "Detected, click link to download now" : " Incompatible with your browser"}</li>
            <li><strong>Firefox</strong> - Unavailable at this time: {browser === "Firefox" ? "Detected" : " Incompatible with your browser"}</li>
            <li><strong>Safari</strong> - Unavailable at this time: {browser === "Safari" ? "Detected" : " Incompatible with your browser"}</li>
        </ul>
        <p>Gaining feedback before expanding to other Browsers. Let me know if you are interested.</p>

    <h3>About the Extension</h3>
        <p>As an engineer with a passion for making life easier, I created the Job Posting Extractor extension to streamline the process of gathering job details for local storage.</p>
        <p>The extension allows users to create TXT files and/or comma delimited information that can be easily pasted into Excel or Google Sheets.</p>
        <p>Hope this saves you time! Please provide feedback if you have any suggestions.</p>
        <p>I would also love to hear if you used the TXT files to run some reports or analyses using AI.</p>
        <p>NotebookLM by Google can run a report on Benefits Packages and rank them against each other.</p>

    <h3>Extension Bar Icon</h3>
        <p>The extension bar icon indicates the status of the extension on the current page. 
            Some postings are hidden in an iframe which hinders the extension from detecting the job posting status. 
            So the extension may still work even if the icon doesn't reflect the correct status. 
            You can verify the extension's status at any time by clicking the "Identify Host" button.</p>

        <div className="light-theme">
            <p>Light Theme:</p>
            <GiCardboardBox className="inActiveExt" size="2em" /> 
            <span>Display's if extension isn't aware of the current pages job posting status.</span><br />
            <GiCardboardBox className="activeExt" size="2em" />
            <span>Display's if extension is correctly identified the job post.</span>
        </div>
        <div className="dark-theme">
            <p>Dark Theme:</p>
            <GiCardboardBox className="inActiveExt" size="2em" /> 
            <span>Display's if extension isn't aware of the current pages job posting status. Check the extension's "Identify Host" button.</span><br />
            <GiCardboardBox className="activeExt" size="2em" /> 
            <span>Display's if extension is correctly identified the job post.</span>
        </div>


    <h3>How Extension Works</h3>
        <p>When you click the "Identify Host" button, the extension will analyze the 
            current job posting page to determine which job board is being used.</p>
        <p>The same process will be used when you choose to extract the job posting 
            data as a text file, column data for spreadsheets, or both.</p>
        <p>Text file will be saved using the following naming convention: [yyyymmdd] - [CompanyName] -- [JobTitle].txt.</p>

    <h3>Hindered Job Postings</h3>
        <p>Some job postings may be hidden in an iframe, which can hinder the extension from extracting the data correctly.</p>
        <p>In these cases, you can open the iframe in a new tab if the posting doesn't have a copy url link.</p>
        <ul>
            <li>To open the iframe in a new tab, you can right-click on the page and select "Inspect".</li>   
            <li>From the HTML you can enter CTRL+F to search for "iframe".</li>
            <li>Identify the iframe src and right-click on the url and select "Open in new tab" from the context menu.</li>
            <li>This will allow you to access the job posting directly and use the extension to extract the data.</li>
        </ul>
        <p><strong>No iframe and still problems</strong></p>
        <p>Some may have a Share link or similar to the right side. Click on that and see if the copy link allows for a cleaner job posting view that will work.</p>
        <p>Others may have an Apply button that goes to a recognized Job Posting company but don't show the job posting any longer. For these trim the URL down.<br />
        Example: <strong>https://ibotta.wd1.myworkdayjobs.com/Ibotta/job/Hybrid---Denver/Engineering-Manager_R-102466/<span className="strike">apply</span></strong>
        </p>

    <h3>Spreadsheet Column Data</h3> 
        <p>By default the columns are ordered as follows:</p>
        <ul>
            <li><strong>Company Name:</strong> Company offering the job.</li>
            <li><strong>Position/Job Title:</strong> The job title.</li>
            <li><strong>URL:</strong> The web address of the job posting.</li>
            <li><strong>Location:</strong> Job location. May include multiple locations or remote only.</li>
            <li><strong>Employment Type:</strong> Indicates if the job is full-time, part-time, or contract (currently hard-coded as "Full-time").</li>
            <li><strong>Mode:</strong> Indicates if the job is remote, in-person, or hybrid.</li>
            <li><strong>Pay:</strong> The salary or wage information for the job.
            <ul>
                <li>If salary range, it will be formatted as "Min to Max" (e.g., "$50K to $70K" or "$51,234 to $71,234").</li>
                <li>A single pay could be all that is listed (e.g., "$60K" or "$61,234").</li>
                <li>If no salary information is available, it will return "???".</li>
            </ul>
            </li>
            <li><strong>Current Date:</strong> The date when the data was extracted, formatted as MM/DD/YYYY.</li>
            <li><strong>Status:</strong> The current status of the job posting (currently hard-coded as "Open").</li>
        </ul>
        <p>Clicking on the "Set Order" toggle button will allow you to select your preferred column order.<br />You can drag and drop the columns to reorder them to your preference.</p>

    <h3>Pasting into Spreadsheet</h3> 
        <p>Note that pasting the information into a spreadsheet may require some manual adjustments.</p>
        <p>Pasting into the first column should show an icon to the bottom right of the pasted data that allows you to split the data into separate columns.</p>
        <figure>
            <img src={require('../assets/paste-1.png')} alt="Pasting into Spreadsheet" />
            <figcaption>Fig.1 - Pasting into Spreadsheet</figcaption>
        </figure>
        <figure>
            <img src={require('../assets/paste-2.png')} alt="Split as Columns" />
            <figcaption>Fig.2 - Split as Columns</figcaption>
        </figure>
        <p>From there you can use paint format to apply the formatting from prior row to new row.</p>
        <figure>
            <img src={require('../assets/paste-paint.png')} alt="Paint Format from prior row" />
            <figcaption>Fig.3 - Paint Format from prior row</figcaption>
        </figure>
        <p><a href="Job Tracker Spreadsheet - Template.xlsx">Download Example Spreadsheet Template</a></p>
        <br /><br />

    <h3>Currently Supported Job Boards</h3>
        <ol>
            <li>Ashby</li>
                {/*<li>Eightfold</li>*/}
            <li>Greenhouse</li>
            <li>iCIMS</li>
            <li>JazzHR</li>
            <li>JobVite</li>
            <li>Lever</li>
            <li>Paylocity</li>
            <li>Rippling</li>
            <li>Workday</li>
            <li>Workable</li>
        </ol>
        <p>More will be added at a future date.</p>
    
    {/* <h3>Chrome Extension Icon</h3>
        <div style={{ width: '128px', height: '128px', position: 'relative' }}>
            <DLogo style={{ color: '#ff6123', display: 'inline', margin: '16px'}} width="96px" height="96px" />
            <GiCardboardBox  style={{ color: '#800080', display: 'inline', position: 'relative', top: '-90px', left: '38px'}} size="38px" />
        </div> */}

    </section>
  );
}

export default Extension;